import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { Link } from 'react-router-dom'
import FontAwesome from 'react-fontawesome'
import Datetime from '../Function/Datetime';
import Pagination from '../Function/Pagination';
import ErrorTypo from './../Function/ErrorTypo';
import RelatedTag from '../Function/RelatedTag';
import API from './../Function/APILink'
import { connect } from 'react-redux'

class Content extends Component {

    constructor(props) {
        super(props)
        
        this.addcounterview = this.addcounterview.bind(this)
        this.state = {
            token: 'qwertygf123456'
        }
    }

    async addcounterview(id) {
        await API.post("AddCounterView.php?token="+this.state.token+"&id="+id)
    }
    
    render(){
        
        const {
            activepage, 
            keyword, 
            sort,
            levelcat,
            category1,
            category2,
            category3,
            contentlist,
            correctkeyword,
            urlparampagging,
        } = this.props
        var totalcontent = contentlist.length
        var contentcard
        var recordperpage = 10
        var totalpage = Math.ceil(totalcontent/recordperpage)
        if("terbaru"===sort){
            this.props.sortTerbaru()
        } else if("terbantu"===sort){
            this.props.sortTerbantu()
        } else if("popular"===sort){
            this.props.sortPopular()
        } else {
            this.props.sortRelevant()
        }
        
        if(""!==totalcontent) {
            if(0 < totalcontent && activepage <= totalpage) {

                var start_record = 1
                var end_record = recordperpage
                
                if(1 < activepage) {
                    start_record = ((activepage - 1) * recordperpage) + start_record
                    end_record = activepage * recordperpage
                }
                
                end_record = (end_record > totalcontent) ? totalcontent : end_record
                
                contentcard = (
                    <>
                        <div className="total">
                            Menampilkan {start_record} - {end_record} dari {totalcontent} hasil 
                            ({(""===category1) ? 'Semua Kategori' : ReactHtmlParser(contentlist[0]['CatName_1'])}
                            {("1"===levelcat || "2"===levelcat) ? ' / ' + ( (""===category2) ? 'Semua Sub Kategori' : ReactHtmlParser(contentlist[0]['CatName_2']) ) : ''}
                            {("2"===levelcat) ? ' / ' + ( (""===category3) ? 'Semua Sub Sub Kategori' : ReactHtmlParser(contentlist[0]['CatName_3']) ) : ''})
                        </div> 
                        
                        <ErrorTypo keyword={keyword} sort={sort} correctkeyword={correctkeyword} {...this.props}/>
                        
                        {contentlist.slice(start_record-1,end_record).map((content, key) => {
                            return (
                                <div className="content-list" key={key}>
                                    <div className="category">
                                        <Link to={`/search?category=${content.CatID_1}&levelcat=1`} onClick={() => this.props.refresh()}>{ReactHtmlParser(content.CatName_1)}</Link>
                                        {("0"!==content.CatID_2) ? <> / <Link to={`/search?category=${content.CatID_1}&category2=${content.CatID_2}&levelcat=2`} onClick={() => this.props.refresh()}>{ReactHtmlParser(content.CatName_2)}</Link></> : ''}
                                        {("0"!==content.CatID_3) ? <> / <Link to={`/search?category=${content.CatID_1}&category2=${content.CatID_2}&category3=${content.CatID_3}&levelcat=3`} onClick={() => this.props.refresh()}>{ReactHtmlParser(content.CatName_3)}</Link></> : ''}
                                    </div>
                                    <div className="title">
                                        <Link 
                                            to={`/detail/${encodeURIComponent(content.URL)}`}
                                            // to={`/detail/${encodeURIComponent(content.URL)}${((start_record + key) < end_record) ? '/'+(contentlist[start_record + key].ContentID) : ''}${((start_record + key + 1) < end_record) ? '-'+(contentlist[start_record + key + 1].ContentID) : ''}${((start_record + key + 2) < end_record) ? '-'+(contentlist[start_record + key + 2].ContentID) : ''}${((start_record + key + 3) < end_record) ? '-'+(contentlist[start_record + key + 3].ContentID) : ''}${((start_record + key + 4) < end_record) ? '-'+(contentlist[start_record + key + 4].ContentID) : ''}`} 
                                            // to={`/detail/${encodeURIComponent(content.URL)}/${contentlist.slice(start_record + key, totalcontent).map(id => { return id.ContentID})}`} 
                                            onClick={() => this.addcounterview(content.ContentID)}>
                                            {content.Title}
                                        </Link>
                                    </div>
                                    <div className="brief">{ReactHtmlParser(content.Description)}</div>
                                    <div className="remark">                                        
                                        <span title={`Tanggal tayang: ${content.OnAirDate}`}><Datetime input={content.OnAirDate}/> </span>
                                        <span className="gf-green" title={`Jumlah dilihat: ${content.View}`}><FontAwesome name="eye"/> {content.View} </span>
                                        <span className="gf-orange" title={`Jumlah terbantu: ${content.Helpful}`}><FontAwesome name='star'/> {content.Helpful}</span>
                                    </div>
                                </div>
                            )
                        })}
                        <RelatedTag {...this.props}/>
                        <Pagination activepage={activepage} totalpage={totalpage} urlparampagging={urlparampagging} {...this.props}/>
                    </>
                )
            } else {
                contentcard =
                    <>
                        <ErrorTypo keyword={keyword} sort={sort} correctkeyword={correctkeyword} {...this.props}/>
                        <div className="content-nolist">
                            Penelusuran Anda <span className="gf-red">{keyword}</span> tidak cocok dengan data apa pun.<br/><br/>
                            Silahkan mencari ulang dengan kata yang lebih tepat dan penulisan yang benar. 
                        </div>
                    </>
            }
        }
        return (
            <div className="content">
                {contentcard}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    contentlist: state.ContentListReducer.contentlist
})

const mapDispatchToProps = (dispatch) => ({
    sortRelevant: () => dispatch({type:'SORT_RELEVANT'}),
    sortPopular: () => dispatch({type:'SORT_POPULAR'}),
    sortTerbaru: () => dispatch({type:'SORT_TERBARU'}),
    sortTerbantu: () => dispatch({type:'SORT_TERBANTU'}),
})

export default connect(mapStateToProps,mapDispatchToProps)(Content)